import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    navWrapClass, navLeftClass, navRightClass,
} from '../classNames';

/**
 * Navigation arrows component
 * @param {Object} props see proptypes
 * @returns {JSX} the navigation arrows
 */
 function NavArrows({ clickHandler, initialNavVisibility: { left, right } }) {
    const leftClassName = classNames('bb-icon bb-icon--expand-arrow', navLeftClass, { disabled: !left });
    const rightClassName = classNames('bb-icon bb-icon--expand-arrow', navRightClass, { disabled: !right });

    return (
        <div data-testid="carousel__nav" className={navWrapClass}>
            <span data-arrow-direction="left" onClick={clickHandler} className={leftClassName} />
            <span data-arrow-direction="right" onClick={clickHandler} className={rightClassName} />
        </div>
    );
}

NavArrows.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    initialNavVisibility: PropTypes.shape({
        left: PropTypes.boolean,
        right: PropTypes.boolean,
        global: PropTypes.boolean,
    }).isRequired,
};

export default NavArrows;
